import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey } from '@hero/utils';

import * as organizationServices from '../../services';

export function useGetInvite(params, options) {
  const query = useQuery(
    createQueryKey(QUERY_KEYS, params),
    async () => {
      return await organizationServices.getInvite({ params });
    },
    {
      enabled: true,
      ...options
    }
  );
  return query;
}
